import type { ReactNode } from 'react'
import { cn } from '../lib/cn'

export type BadgeTone = 'neutral' | 'brand' | 'accent' | 'violet' | 'amber'

export interface BadgeProps {
  children: ReactNode
  tone?: BadgeTone
  className?: string
}

export function Badge({ children, tone = 'neutral', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded px-1.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide',
        tone === 'neutral' && 'bg-neutral-100 text-neutral-500',
        tone === 'brand' && 'bg-brand-100 text-brand-700',
        tone === 'accent' && 'bg-accent-50 text-accent',
        tone === 'violet' && 'bg-reasoning-soft text-reasoning',
        tone === 'amber' && 'bg-scope-soft text-scope',
        className,
      )}
    >
      {children}
    </span>
  )
}
